import { CurrencyCode } from "Models/CurrencyCodes";

const PRESETS_BY_CURRENCY: Record<CurrencyCode, ReadonlyArray<number>> = {
  [CurrencyCode.CZK]: [25, 50, 100, 200],
  [CurrencyCode.EUR]: [1, 2, 5, 10],
  [CurrencyCode.USD]: [1, 2, 5, 10],
  [CurrencyCode.GBP]: [1, 2, 5, 10],
  [CurrencyCode.PLN]: [5, 10, 20, 50],
  [CurrencyCode.CHF]: [1, 2, 5, 10],
  [CurrencyCode.BTC]: [],
};

const DEFAULT_PRESETS: ReadonlyArray<number> = [10, 25, 50, 100];

export const getAmountPresetsForCurrency = (
  currencyCode?: string | null,
): ReadonlyArray<number> => {
  if (!currencyCode) {
    return DEFAULT_PRESETS;
  }

  const presets = PRESETS_BY_CURRENCY[currencyCode as CurrencyCode];
  return presets ?? DEFAULT_PRESETS;
};
